import { mobileApiRequest } from '../../apiRequests'

/**
 * Create a Chargebee checkout session for upgrading to a new tier.
 *
 * @param {string} tier - The tier to upgrade to ('individual', 'team', or 'enterprise')
 * @param {string} accountID - The account ID for the user
 * @returns {Promise<{checkoutUrl: string, expiresIn: number}>}
 */
export const createCheckoutSession = async (tier, accountID) => {
    // Capitalize tier name for backend API
    const capitalizedTier = tier.charAt(0).toUpperCase() + tier.slice(1)

    const action = {
        action: 'createCheckoutSession',
        tier: capitalizedTier,
        accountID,
    }
    return await mobileApiRequest(action)
}

/**
 * Create a Chargebee billing portal session for managing subscription.
 *
 * @param {string} accountID - The account ID for the user
 * @returns {Promise<{portalUrl: string, expiresIn: number}>}
 */
export const createPortalSession = async (accountID) => {
    const action = {
        action: 'createPortalSession',
        accountID,
    }
    return await mobileApiRequest(action)
}
